import { PropType, reactive } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';
import UserProSkillEntity from '@/entity/UserProSkillEntity';
import { useNotif } from '@orion.ui/orion';
import useProfessionalSkillService from '@/services/ProfessionalSkillService';
import UserProfileInformationsEntity from '@/entity/user-profile/UserProfileInformationsEntity';

type Props = SetupProps<typeof UserProfileProSkillAsideNewSetupService.props>

export default class UserProfileProSkillAsideNewSetupService extends BaseSetupService<Props> {
	static readonly props = {
		userProfileInformationsEntity: {
			type: Object as PropType<UserProfileInformationsEntity>,
			default: undefined,
		},
	};

	entity = new UserProSkillEntity();

	private _modal?: OrionModal;
	private readonly state = reactive({
		newUserProSkill: undefined as Undef<IProfessionalSkillModel>,
		skillOptions: [] as IProfessionalSkillModel[],
	});

	get skillOptions () {return this.state.skillOptions;};

	get newUserProSkill () { return this.state.newUserProSkill; }
	set newUserProSkill (val) { this.state.newUserProSkill = val; }


	constructor (props: Props, _modal?: OrionModal) {
		super(props);
		this._modal = _modal;

		if (this.props.userProfileInformationsEntity) {
			this.entity.connectUserProfileInformationsEntity(this.props.userProfileInformationsEntity);
		}
	}

	protected async onBeforeMountAsync (): Promise<void> {
		this.state.skillOptions = await useProfessionalSkillService().getAsync();
	}


	async addUserProSkillAsync () {
		if (!this.state.newUserProSkill) return;

		this.entity.assignData(this.state.newUserProSkill);

		await this.entity.addAsync(() => {
			useNotif.success('Sauvegarde réussie', 'Votre qualification a bien été ajoutée à votre profil');
			this._modal?.trigger('added');
			this._modal?.close();
		});
	}
}
